import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ContentCreate from '@material-ui/icons/Create';
import ContentView from '@material-ui/icons/Visibility';
import {
  ROLE_ADMIN, ROLE_COMPANY_ADMIN, ROLE_COMPANY_MANAGER, ROLE_CALLCENTER_ADMIN
} from '../config';
import {hasAccess} from '../common';

const ROLES_THAT_CAN_EDIT = [ROLE_ADMIN, ROLE_COMPANY_ADMIN, ROLE_COMPANY_MANAGER, ROLE_CALLCENTER_ADMIN];

const checkIsCanEdit = (page, record, user) => {
  if (page !== 'customer') return true;
  if (user && hasAccess(user.role, ROLES_THAT_CAN_EDIT)) return true;
  if (user) return record.created_user_id === user.id;

  return false;
};

const getButton = (isCanEdit) => {
  if (isCanEdit) {
    return (
      <ContentCreate style={{ width: '18px', height: '18px' }} />
    );
  }
  return (
    <ContentView style={{ width: '18px', height: '18px' }} />
  );
};

const SecretaryEditButton = ({
  currentpage, record, click, user
}) => {
  const isCanEdit = checkIsCanEdit(currentpage, record, user);
  return (
    <IconButton
      color="primary"
      onClick={click('edit', true, record)}
      style={{ maxWidth: '100%', height: '27px' }}
      disabled={!isCanEdit}
      disableRipple
      disableTouchRipple
    >
      {getButton(isCanEdit)}
    </IconButton>
  );
};

SecretaryEditButton.defaultProps = {
  user: null
};

SecretaryEditButton.propTypes = {
  click: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  className: PropTypes.string,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  currentpage: PropTypes.string.isRequired
};

const mapStateToProps = state => (
  {
    user: state.sc.user,
    currentpage: state.sc.currentpage
  }
);


export default connect(mapStateToProps)(SecretaryEditButton);



// WEBPACK FOOTER //
// ./src/components/SecretaryEditButton.js